<template>
<div>
    <div
        id="loader-cover"
        class="loader-cover active">
      <div class="loader-content">
        <div class="loader-icon loader--style7" title="6">
        </div>
      </div>
    </div>
</div>
</template>


<script>
  export default {
      data () {
         return {
             isLoading: false,
         }
      },
    computed: {
      loading () {
          console.log('loading store', this.$store.state.loading)
          if (this.$store.state.loading) {
              this.isLoading = true
          } else {
              this.isLoading = false;
          }
        return this.$store.state.loading
      },
        store () {
          return this.$store.state;
        }
    },
  }
</script>

<style lang="scss">
#loader-cover {
    display: none;
    position: fixed;
    z-index: 10000;
    top: 0px;
    left: 0;
    background: rgba(255, 255, 255, 0.3);
    text-align: center;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

#loader-cover .loader-content {
    position: fixed;
    z-index: 10000;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

#loader-cover.loader-cover.active {
    display: block;
}
.loader-icon:not(:required) {
  -webkit-animation: loader 1000ms infinite linear;
  -moz-animation: loader 1000ms infinite linear;
  -ms-animation: loader 1000ms infinite linear;
  -o-animation: loader 1000ms infinite linear;
  animation: loader 1000ms infinite linear;
  -webkit-border-radius: 0.5em;
  -moz-border-radius: 0.5em;
  -ms-border-radius: 0.5em;
  -o-border-radius: 0.5em;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.3) 1.5em 0 0 0, rgba(0, 0, 0, 0.3) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.3) 0 1.5em 0 0, rgba(0, 0, 0, 0.3) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.3) -1.5em 0 0 0, rgba(0, 0, 0, 0.3) -1.1em -1.1em 0 0,
  rgba(0, 0, 0, 0.3) 0 -1.5em 0 0, rgba(0, 0, 0, 0.3) 1.1em -1.1em 0 0;
  -moz-box-shadow: rgba(0, 0, 0, 0.3) 1.5em 0 0 0, rgba(0, 0, 0, 0.3) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.3) 0 1.5em 0 0, rgba(0, 0, 0, 0.3) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.3) -1.5em 0 0 0, rgba(0, 0, 0, 0.3) -1.1em -1.1em 0 0,
  rgba(0, 0, 0, 0.3) 0 -1.5em 0 0, rgba(0, 0, 0, 0.3) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.3) 1.5em 0 0 0, rgba(0, 0, 0, 0.3) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.3) 0 1.5em 0 0, rgba(0, 0, 0, 0.3) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.3) -1.5em 0 0 0, rgba(0, 0, 0, 0.3) -1.1em -1.1em 0 0,
  rgba(0, 0, 0, 0.3) 0 -1.5em 0 0, rgba(0, 0, 0, 0.3) 1.1em -1.1em 0 0;
  display: inline-block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin: 1.5em;
  overflow: hidden;
  text-indent: 100%;
}
</style>
